if (window.localStorage.quizKitResultsProducts) {
  const parsedHTML = JSON.parse(window.localStorage.quizKitCustomerCompletions);
  var currentProducts = parsedHTML['0uPhDQ29Otg']['recommendedProducts'];

  setProperty();

  function setProperty() {
    const $haeader = $('header.header');

    setTimeout(() => {
      document.documentElement.style.setProperty('--header-height', $haeader.outerHeight() + 'px');
    },200);
  }

  const amountProductPerLine = currentProducts.length >= 4 ? 4 : 3;

  document.documentElement.style.setProperty('--product-per-line', amountProductPerLine );

  let containerForProductList = $('.quiz-kit__product-result-inner--list'),
    containerSingleProductBlockInner = $(".quiz-kit__product-result--single .quiz-kit__product-result-inner--single"),
    containerForSingleProduct = $(".quiz-kit__product-result-inner--single"),
    currentTag = containerForSingleProduct.attr('data-tag-for-selection'),
    tagsForfiltration = $('.quiz-kit__product-wrapper').attr('data-tags-for-sorting'),
    stringTags = (currentTag) ? currentTag + ',' + tagsForfiltration : tagsForfiltration,
    arrayTags = stringTags.split(','),
    secondTags = stringTags.split(','),
    mainArray = [],
    otherProductsArray = [];

  const promises = currentProducts.map((item) => {
    return new Promise((resolve, reject) => fetch(`/products/${item.handle}?variant=${item.variants[0].id}&view=quiz-kit-result-2`, {
        credentials: 'same-origin',
        method: 'GET'
      })
        .then((response) => response.text())
        .then(function(response) {
          const DOMElement = new DOMParser().parseFromString(response, "text/html");
          const productCard = DOMElement.body.firstChild;

          resolve(productCard);
        })
    )
  });

  Promise.all(promises).then(value => {
    value.forEach((element, index) => {
      let flag = false;
      arrayTags.forEach((tag, index) => {
        if (element.dataset.tags.includes(tag) && !flag) {

          flag = true;
          mainArray.push({obj: element, tag: tag});
          arrayTags.splice(index,1);
          return false;
        }
      });

      if (!flag) {
        otherProductsArray.push({obj: element, tag: 'other'});
      }
    });

    const resultArray = secondTags.reduce((current, next) => {
      const result = mainArray.find((element) => element.tag === next);

      if(result) {
        current.push(result);
      }

      return current;
    }, []);

    const finalArray= resultArray.concat(otherProductsArray);

    finalArray.forEach( (element, index) => {
      index += 1

      if (element) {
        const productReviewsJson = $(element.obj).find('[data-id-product-reviews]').html()
        const parsedJsonReviews = JSON.parse(productReviewsJson);

        window.PR_RENDER_LIST = window.PR_RENDER_LIST || [];
        window.PR_RENDER_LIST.push(parsedJsonReviews);

        if (element.tag == 'it-product') {
          // 1. Your IT Product
          $(element.obj).find('.product-grid-item__info-title-tag').html('Your IT Product')
        } else if (element.tag == 'rinse-product') {
          // 2. Cleanse
          $(element.obj).find('.product-grid-item__info-title-tag').html('Cleanse')
        } else if (element.tag == 'treatment-product') {
          // 3. Restore Moisture
          $(element.obj).find('.product-grid-item__info-title-tag').html('Restore Moisture')
        } else if (element.tag == 'shampoo-product') {
          // 4. Maintain Vibrancy
          $(element.obj).find('.product-grid-item__info-title-tag').html('Maintain Vibrancy')
        } else if (element.tag == 'conditioner-product') {
          // 5. Conditioner
          $(element.obj).find('.product-grid-item__info-title-tag').html('Conditioner')
        } else {
          $(element.obj).find('.product-grid-item__info-title-tag').html('Bonus Suggestions')
        }

        if (containerForSingleProduct && element.tag == currentTag) {
          containerForSingleProduct.append(element.obj);
          containerSingleProductBlockInner.removeClass('visually-hidden');
        } else {
          containerForProductList.append(element.obj);
        }
      }
    })

  }).then(() => {
    setTimeout(() => {
      POWERREVIEWS.display.render(window.PR_RENDER_LIST);
    }, 500)
  })

  $(document).on('click', '.quiz-kit__product-result-inner .product-grid-item .quick-add__submit', function (e) {
    e.preventDefault();
    const $select = $(this).parents('form[action="/cart/add"]').find('[data-product-select]');
    const $cardWrapper = $(this).parents('.quiz-kit__product-wrapper').find('.quiz-kit__product-summary-cart');
    const cardButton = $(this).parents('.quiz-kit__product-wrapper').find('.quiz-kit__product-summary-cart-item-button');
    const cardButtonCount = cardButton.find('.products-count');
    const cardButtonPrice = cardButton.find('.products-price');

    //----change product to checked and change btn label to remove
    ($select.attr('data-product-select') === 'true') ? $select.attr('data-product-select', 'false') : $select.attr('data-product-select', 'true');
    ($(this).attr('data-label-remove') === 'true') ? $(this).attr('data-label-remove', 'false') : $(this).attr('data-label-remove', 'true');

    const $productSelected = $('[data-product-select="true"]');
    const $optionSelected = $productSelected.find('option[selected]');

    let sumPrice = 0;
    //----create and append html to summary bag
    let resultHTML = Array.from($optionSelected).map(function(elem, index) {
      const title = elem.getAttribute('data-product-title');
      const price = elem.getAttribute('data-variant-price') / 100;
      const variantId = elem.value;
      sumPrice =  price + sumPrice;

      return '<div class="quiz-kit__product-summary-cart-item bundle" data-property="6558" data-variant-id="'+variantId+'"><span class="quiz-kit__product-summary-cart-item-title">'+ title +'</span><span class="quiz-kit__product-summary-cart-item-price">' + '$' + price +'</span></div>';
    });
    if(resultHTML.length) {
      document.querySelector('.not-ready-commit').style.display = 'block';
    } else {
      document.querySelector('.not-ready-commit').style.display = 'none';
    }
    $cardWrapper.html(resultHTML);
    cardButtonCount.html((resultHTML.length > 1) ? resultHTML.length+' Items' : resultHTML.length+' Item');
    cardButtonPrice.html('$' + sumPrice);
    (resultHTML.length > 0) ? cardButton.attr('aria-hidden', 'false') : cardButton.attr('aria-hidden', 'true');
  });

  function sendDataToQuizkitapp($optionSelected) {

    Array.from($optionSelected).forEach((elem) => {
      let variantId = $(elem).parents('form[action="/cart/add"]').find('[data-product-select]').val();

      console.log(variantId, 'variantId')

      $.ajax({
        type: 'POST',
        data: JSON.stringify({price: $(elem).attr('data-variant-price'), variantId: parseInt(variantId, 10)}),
        url: 'https://api.quizkitapp.com/api/v1/quizzes/0uPhDQ29Otg/add-to-cart',
        dataType: 'json',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
    })
  }

  $('.quiz-kit__product-summary-cart-item-button').on('click', function (e) {
    const $optionSelected = $('[data-product-select="true"] option[selected]');

    sendDataToQuizkitapp($optionSelected);

    // Array.from($optionSelected).forEach((elem) => {
    //   let variantId = $(elem).parents('form[action="/cart/add"]').find('[data-product-select]').val();
    
    //   $.ajax({
    //     type: 'POST',
    //     data: JSON.stringify({price: $(elem).attr('data-variant-price'), variantId: parseInt(variantId, 10)}),
    //     url: 'https://api.quizkitapp.com/api/v1/quizzes/0uPhDQ29Otg/add-to-cart',
    //     dataType: 'json',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'X-Requested-With': 'XMLHttpRequest'
    //     }
    //   });
    // })
  });

  $('.quiz-kit__product-summary-cart-item-button--add-all').on('click', function (e) {
    const $optionSelected = $('[data-product-select] option[selected]');

    sendDataToQuizkitapp($optionSelected);
  });
}

